import React from 'react';
import { Button } from '@material-ui/core';


const CustomizeButton = () => {
  return (
    <Button
      color="primary"
      variant="contained"
      className="uppercase text-12 font-bold px-3"
    >
      Customize
    </Button>
  );
};

export default CustomizeButton;
